import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-icon-sun',
    templateUrl: './icon-sun.component.html',
    styleUrls: ['./icon-sun.component.scss'],
    standalone: false
})
export class IconSunComponent {
  @Input() color = '#FFDC82';
  @Input() width = '312';
  @Input() height = '160';
}
